if ($('.products-recommended').length) {
	// Find the container that will hold the recommendations
	const list = document.querySelector('.products-recommended');
	const listBody = document.querySelector('.products-recommended .products__body');
	let getPath = window.location.href;
	let getCollectionName = '';

	if (getPath.indexOf('collections') > -1) {
		let splitGetPath = getPath.split('collections')[1].split('/')[1];
		getCollectionName = `/collections/${splitGetPath}/products/`;
	}
	// Get the product id to request the product recommendations
	const productId = list.dataset.productId;
	// get the limit data
	const limit = list.dataset.limit;
	// Create an AJAX request
	const request = new XMLHttpRequest();

	request.open('GET', '/recommendations/products.json?product_id=' + productId + '&limit=' + limit + '');

	request.onload = function() {
		if (request.status === 404 || request.status === 422) {
			return hideRecommendationsSection();
		}

		let products = JSON.parse(request.response).products;

		if (products.length <= 0) {
			return hideRecommendationsSection();
		}

		// Select the empty product card that was rendered by liquid
		let productCardTemplate = document.querySelector('.product-recommended');

		let fragment = document.createDocumentFragment(); // Create a fragment that will hold the product cards
		products.forEach(function(product) {
			const template = productCardTemplate.cloneNode(true);
      const isAlternate = product.tags.some(tag => tag === 'alternate')
			let newHtml = '';
			let productUrl = product.url;

			if (product.type) {
				newHtml = `<span>${product.type}</span>`;
			}

			if (product.variants[0].title == 'Default Title') {
				newHtml += `<span>${product.title}</span>`;
			} else {
				newHtml += `<span>${product.variants[0].title}</span>`;
			}
			const convertPrice = formatPrice(product.price);

			if (getPath.indexOf('collections') > -1) {
				let getProductName = product.url.split('/')[2].split('?')[0];
				productUrl = getCollectionName + getProductName;
			}

      if(isAlternate){
        newHtml = `<span>${product.title}</span>`
      }

			template.querySelector('.product__link').href = productUrl;
			template.querySelector('.product__image').style.backgroundImage = `url(${product.featured_image})`;
			template.querySelector('.product__price .money').innerHTML = convertPrice;
			template.querySelector('.product__info').innerHTML = newHtml;
			fragment.appendChild(template);
		});
		listBody.removeChild(productCardTemplate); // Delete the template output by liquid
		listBody.appendChild(fragment); // Display recommendations
	};

	request.onerror = function() {
		hideRecommendationsSection();
	};

	// Send AJAX request
	request.send();

	function hideRecommendationsSection() {
		list.style.display = 'none';
	}

	function formatPrice(cents) {
		return (cents / 100).toLocaleString('en-GP', {
			style: 'currency',
			currency: 'GBP'
		});
	}
}
